module.exports = __webpack_public_path__ + "static/media/icon-salaire.9ef1627a.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/icons/icon-salaire.svg
// module id = 618
// module chunks = 0